<template>
  <div>
    <v-col class="pa-0" cols="12" :style="offset">
      <template>
        <v-card
          class="mx-auto"
          tile
          :style="offset"
          elevation="0"
          :color="cardColor"
        >
          <v-list-item class="comment-content">
            <v-avatar :color="userColorsMap[item.user_id]" class="mr-3 avatar" size="34" left>
              <span class="white--text text-caption">{{ item.initials }}</span>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-1">{{ item.user }}</v-list-item-title>
              <div class="overline mb-4">{{ item.created_at }}</div>
              <div class="text--primary comment-text" v-html="item.comment"></div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-divider></v-divider>
      </template>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const COLORS = [
  'white',
  'grey lighten-5',
  'grey lighten-4',
  'grey lighten-3',
  'grey lighten-2',
];

export default {
  // MUST give a name in recursive components
  // https://vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
  name: 'Comment',

  props: {
    item: { type: Object, required: true },
    depth: { type: Number, default: 0 },
  },

  data() {
    return {
      childrenCount: 0,
      voptions: {
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: true,
        tooltip: false,
        movable: false,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: false,
        fullscreen: false,
        keyboard: false,
        url: "data-source",
      },
    };
  },

  computed: {
    ...mapGetters({
      users: 'data/users'
    }),
    direct() {
      if (Array.isArray(this.item.children)) {
        return this.item.children.length;
      }
      return 0;
    },

    offset() {
      return {
        'padding-left': (this.depth * 20) + 'px',
      };
    },

    cardColor() {
      return COLORS[this.depth % COLORS.length];
    },

    userColorsMap() {
      // Define an array of colors. Feel free to change these values.
      const colors = [
        'red lighten-2',
        'blue lighten-2',
        'green lighten-2',
        'amber lighten-2',
        'purple lighten-2',
        'pink lighten-2',
        'deep-orange lighten-2',
        'teal lighten-2'
      ];
      return this.users.reduce((map, user, index) => {
        // You can use index-based assignment, or calculate a hash from user.name for more randomness.
        map[user.id] = colors[index % colors.length];
        return map;
      }, {});
    },
  },

  mounted() {
    this.$emit('born');
  },

  methods: {
    handleBorn() {
      this.childrenCount++;
      this.$emit('born');
    },
  },
};
</script>

<style lang="sass" scoped>
.comment-actions
  padding-left: 50px

.comment-content 
  align-items: flex-start

.avatar 
  margin-top: 15px
</style>